import type { operations } from '@/types/schemas/calcs.main';
import { POST } from '../_http';

type controllerV1 = operations['NetSurplusControllerV1_calculate'];
type controllerV2 = operations['NetSurplusControllerV2_calculate'];

export type NetSurplusBodyV1 = controllerV1['requestBody']['content']['application/json'];
export type NetSurplusResponseV1 = controllerV1['responses']['200']['content']['application/json'];
export type NetSurplusBodyV2 = controllerV2['requestBody']['content']['application/json'];
export type NetSurplusResponseV2 = controllerV2['responses']['200']['content']['application/json'];

export const netSurplusV1 = POST('/v1/formulas/net-surplus')<NetSurplusBodyV1, NetSurplusResponseV1>;
export const netSurplusV2 = POST('/v2/formulas/net-surplus')<NetSurplusBodyV2, NetSurplusResponseV2>;

export const netSurplus = async (
  body: NetSurplusBodyV1 | NetSurplusBodyV2,
  structuralVersionNumber?: number,
): Promise<NetSurplusResponseV1 | NetSurplusResponseV2> => {
  structuralVersionNumber = structuralVersionNumber || parseInt(import.meta.env.VITE_STRUCTURAL_VERSION_NUMBER || '0');
  if (structuralVersionNumber === 1) {
    const { data } = await netSurplusV1(body);
    return data;
  }
  const { data } = await netSurplusV2(body);
  return data;
};
